var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgECoolingTabsValve = function SvgECoolingTabsValve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 218,
    width: 28,
    height: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 213,
    width: 2,
    height: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "95.01 222.99 107.5 215.86 107.49 230.14 95.01 222.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,216.72v12.55s-10.98-6.29-10.98-6.29l10.98-6.27M108,215l-14,7.99,13.99,8.01v-16h.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "80.51 215.86 92.99 222.99 80.5 230.14 80.51 215.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.01,216.72l10.98,6.27-10.98,6.29v-12.55M80.01,215v16s13.99-8.01,13.99-8.01l-13.99-7.99h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 202,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,192c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M94,191c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.36,198.65l1.64,4.36,1.64-4.36h1.28v5.69h-.98v-1.88l.1-2.51-1.68,4.38h-.71l-1.68-4.38.1,2.5v1.88h-.98v-5.69h1.28Z"
  })))));
};
export default SvgECoolingTabsValve;